import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import {
  InteractionStatus,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import envConfig from "../config.json";
const LOGINSUCCESS = "LoginSuccess";

export const LoginRedirect = (props) => {
  const { checkRole } = props;
  const navigate = useNavigate();
  const { instance, inProgress, accounts } = useMsal();

  /**
   * Component used to handle the Login redirect
   * @param {*} props properties of the component
   * @returns
   */
  const fetchUserRoles = async (accessToken, checkRole, navigate) => {
    const getConfig = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    try {
      const response = await axios.get(
        `${envConfig.aotmwapi}/api/people-management/users/bytoken`,
        getConfig
      );
      const roleData = response.data.Users[0].UserRoles;
      const isAdmin = roleData.some((item) => item.RoleName === "Admin_3D");
        localStorage.setItem("checkRole", isAdmin);
        localStorage.setItem("TwinBuilder3DTheme", "dark");
      sessionStorage.setItem("authId", accounts[0]?.idTokenClaims?.sub);
      sessionStorage.setItem("userName", accounts[0]?.username);
      checkRole(isAdmin);
      if (isAdmin) {
        navigate("/model", { replace: true });
      } else {
          localStorage.clear();
        navigate("/adminError", { replace: true });
      }
    } catch (error) {
      console.error("Error fetching user roles:", error);
    }
  };

  /**
   * React hook to handle side effect
   */
  useEffect(() => {
    const accessTokenRequest = {
      scopes: [`${envConfig.clientId}/access_as_user`],
      account: accounts[0],
      forceRefresh: true,
    };
    if (inProgress === InteractionStatus.None) {
      sessionStorage.setItem('login-inprogress', 1);
      instance
        .acquireTokenSilent(accessTokenRequest)
        .then((accessTokenResponse) => {
          const accessToken = accessTokenResponse.accessToken;
          localStorage.setItem("msal.accesstoken", accessToken);
          fetchUserRoles(accessToken, checkRole, navigate);
          // rasising event to call plantlist api after login
          const evt = new CustomEvent(LOGINSUCCESS);
          window.dispatchEvent(evt);
          sessionStorage.setItem('login-inprogress', 0);
        })
        .catch((error) => {
          sessionStorage.setItem('login-inprogress', 0);
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          } else {
            console.error("Token acquisition error:", error);
          }
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instance, accounts, inProgress]);

  return <p></p>;
};
